import React from 'react'
import './ui.css'

function PageTitle ({
  as: Component = 'h1',
  children,
  className = '',
  ...props
}) {
  return (
    <Component className={`ds-page-title ${className}`.trim()} {...props}>
      {children}
    </Component>
  )
}

export default PageTitle
